import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import { getNamespaceByAction, getStateByFeatureAndNamespace, DEFAULT_FEATURE, defaultNamespace } from '@redux-syringe/namespaces';
var makeThunkMiddleware = function makeThunkMiddleware(dependencies) {
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
      getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          var namespace = getNamespaceByAction(action);
          var getNamespacedState = function getNamespacedState(feature) {
            if (!namespace) {
              return undefined;
            }
            var namespacedState = getStateByFeatureAndNamespace(feature !== null && feature !== void 0 ? feature : DEFAULT_FEATURE, namespace, getState());
            return namespacedState;
          };
          var thunkApiDispatch = function thunkApiDispatch(otherAction) {
            return dispatch(namespace ? defaultNamespace(namespace, otherAction) : otherAction);
          };
          return action(_objectSpread({
            dispatch: thunkApiDispatch,
            getState: getState,
            namespace: namespace,
            getNamespacedState: getNamespacedState
          }, dependencies));
        }
        return next(action);
      };
    };
  };
  middleware.withDependencies = makeThunkMiddleware;
  return middleware;
};
var thunkMiddleware$1 = makeThunkMiddleware();
var thunkMiddleware = thunkMiddleware$1;
export { thunkMiddleware as default, thunkMiddleware$1 as thunkMiddleware };